import React from "react";
import { useTranslation } from "react-i18next";

function NoDataResons(props: any) {
  const [t] = useTranslation();
  return (
    <>
      {props.from === "appointment" ? (
        <div className="">
          <h5 className="fw-bold">{t("No Appointment?")}</h5>
          <ul>
            <li className="mt-3">
              {t(
                "Check your document id from the profile screen to ensure you are using the correct document id. If it's incorrect, please delete your account and register again with the correct details."
              )}
            </li>
            <li className="mt-3">
              {t(
                "Please check if you have selected the right patient from the dropdown."
              )}
            </li>
          </ul>
        </div>
      ) : props.from === "report" ? (
        <div className="">
          <h5 className="fw-bold">{t("No Diagnostic Report?")}</h5>
          <ul>
            <li className="mt-3">
              {t(
                "Check your document id from the profile screen to ensure you are using the correct document id. If it's incorrect, please delete your account and register again with the correct details."
              )}
            </li>
            <li className="mt-3">
              {t(
                "Your complete report might not have released yet, please call +971 80055 to know more."
              )}
            </li>
            <li className="mt-3">
              {t(
                "Please check if you have selected the right patient from the dropdown."
              )}
            </li>
            <li className="mt-3">
              {t("Your report might be more than 6 months old.")}
            </li>
          </ul>
        </div>
      ) : (
        <div className="">
          <h5 className="fw-bold">{t("No Medication?")}</h5>
          <ul>
            <li className="mt-3">
              {t(
                "Check your document id from the profile screen to ensure you are using the correct document id. If it's incorrect, please delete your account and register again with the correct details."
              )}
            </li>
            <li className="mt-3">
              {t(
                "Please check if you have selected the right patient from the dropdown."
              )}
            </li>
          </ul>
        </div>
      )}
    </>
  );
}

export default NoDataResons;
